module.exports = __webpack_public_path__ + "static/img/word_train_2x.b1e24c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rehabitation/word_train_2x.png
// module id = NnB2
// module chunks = 1